import type { SessionStorageEntries } from '@sorare/core/src/lib/storage/sessionStorage';
import {
  SESSION_STORAGE,
  sessionStorage,
} from '@sorare/core/src/lib/storage/sessionStorage';

const isValid = (
  composeTeamSelection: Nullable<
    SessionStorageEntries[SESSION_STORAGE.composeTeamSelection]
  >
) => {
  if (!composeTeamSelection) {
    return true;
  }
  if (
    !composeTeamSelection.so5LeaderboardSlug ||
    !composeTeamSelection.benchObjectIds.every(
      id =>
        !id ||
        id.startsWith('ComposeTeamBenchCard') ||
        id.startsWith('ComposeTeamBenchCommonPlayer')
    )
  ) {
    return false;
  }
  return true;
};

export const getStoredComposeTeamSelection = (
  so5LeaderboardSlug: Nullable<string>
) => {
  const composeTeamSelection = sessionStorage.getValue(
    SESSION_STORAGE.composeTeamSelection
  );
  return (
    // allow so5LeaderboardSlug to be null for case when
    // it's not provided, e.g. in onboarding flow
    (!so5LeaderboardSlug ||
      so5LeaderboardSlug === composeTeamSelection?.so5LeaderboardSlug) &&
      isValid(composeTeamSelection)
      ? composeTeamSelection
      : null
  );
};

export const getStoredComposeQueryVariables = (
  so5LeaderboardSlug: Nullable<string>
) => {
  const composeTeamSelection =
    getStoredComposeTeamSelection(so5LeaderboardSlug);
  const benchObjectIds =
    composeTeamSelection?.benchObjectIds.filter(Boolean) || [];
  const appearancesInput = benchObjectIds.map(benchObjectId => ({
    captain: false,
    composeTeamBenchObjectId: benchObjectId,
  }));
  return {
    benchObjectIds,
    appearancesInput,
  };
};
